export var DefaultTags;
(function (DefaultTags) {
    DefaultTags["MATERIAL"] = "Material";
    DefaultTags["LOCATION"] = "Location";
    DefaultTags["TRADE"] = "Trade";
})(DefaultTags || (DefaultTags = {}));
export var CostCodeType;
(function (CostCodeType) {
    CostCodeType["COST_CODE"] = "cost_code";
    CostCodeType["DIVISION"] = "division";
})(CostCodeType || (CostCodeType = {}));
